export const SET_TASKS = 'SET_TASKS';
export const SET_TASK = 'SET_TASK';
export const ADD_TASK = 'ADD_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const CLEAR_TASK = 'CLEAR_TASK';
export const CLEAR_TASKS = 'CLEAR_TASKS';
